import { InjectionToken, Type } from '@angular/core';

import { TaskType } from '../models/task.interface';

export interface TaskSummaryRenderer {
  readonly type: TaskType;
  readonly component: Type<unknown>;
}

export const TASK_SUMMARY_RENDERERS = new InjectionToken<TaskSummaryRenderer[]>('TASK_SUMMARY_RENDERERS');
